// extracted by mini-css-extract-plugin
export default {"container":"InputFile_container__CrbKb","input":"InputFile_input__8CcB4","label":"InputFile_label__DchRu"};